import { Component } from '@angular/core';

@Component({
    selector: 'fi-business-area-list-container',
    template: ` <fi-business-area-list></fi-business-area-list>`,
    styleUrls: ['./business-area-list-container.component.scss'],
    standalone: false,
})
export class BusinessAreaListContainerComponent {}
